import { make } from "./dom";

const parseRGBA = (rgbaString) => {
  const values = rgbaString.match(
    /rgba\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*\)/i
  );
  if (!values || values.length < 5) {
    return null;
  }

  return [
    Math.round(parseFloat(values[1])),
    Math.round(parseFloat(values[2])),
    Math.round(parseFloat(values[3])),
    parseFloat(values[4]),
  ];
};

export const toRGBA = (hex, alpha = 1) => {
  if(hex==="#00000000"){
    hex="#000000";
  }
  hex = hex.replace(/^#/, "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }

  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return [r, g, b, alpha];
};

export default function colorPicker(swatches, onPick) {
  const colorPickerMain = make("div", ["picker-main"]);
  const colorSection = make("div", ["picker-section", "color-section"]);
  const colorSectionTitle = make("label", [
    "picker-title",
    "picker-color-label",
  ]);
  const colorSectionSwatchGroup = make("div", ["picker-swatch-group"]);
  const opacitySection = make("div", ["picker-section", "opacity-section"]);
  const opacitySectionTitle = make("label", [
    "picker-title",
    "picker-opacity-label",
  ]);
  const opacitySlider = make("input", ["picker-slider"]);
  let target = null;
  let colorValue = "";
  const setTarget = (el) => {
    target = el;
    const dataColor = target.getAttribute("data-color");
    if (target !== null && dataColor !== "" && dataColor !== null) {
      colorValue = parseRGBA(dataColor);
    }
  };
  const getTarget = () => target;
  const setOpacity = (value) => {
    opacitySlider.value = value;
  };

  colorSectionTitle.innerText = "Colour";
  opacitySectionTitle.innerText = "Opacity";

  opacitySlider.type = "range";
  opacitySlider.min = 0;
  opacitySlider.max = 1;
  opacitySlider.step = 0.01;

  const updateColor = (newColor) => {
    if (target !== null) {
      target.setAttribute("data-color", newColor);
      const colorBtn = target.querySelector(".chart-color-picker-btn");
      colorBtn.style.backgroundColor = newColor;
    }
    if (onPick && typeof onPick === "function") {
      onPick();
    }
  };

  const addSwatch = (swatchColor) => {
    const swatch = make("button", ["picker-swatch"]);
    swatch.style.backgroundColor = swatchColor;
    if (swatchColor === "#00000000") {
      swatch.classList.add("transparent");
    }
    swatch.addEventListener("click", () => {
      colorValue =
        swatchColor === "#00000000"
          ? toRGBA("#FFFFFF", 0)
          : toRGBA(swatchColor, 1);
      opacitySlider.value = 1;
      opacitySlider.disabled = false;
      updateColor(`rgba(${colorValue.join(",")})`);
    });
    colorSectionSwatchGroup.appendChild(swatch);
  };

  swatches.forEach((swatchColor) => addSwatch(swatchColor));

  opacitySlider.addEventListener("input", (e) => {
    colorValue[3] = parseFloat(e.target.value);
    updateColor(`rgba(${colorValue.join(",")})`);
  });

  colorSection.appendChild(colorSectionTitle);
  colorSection.appendChild(colorSectionSwatchGroup);
  opacitySection.appendChild(opacitySectionTitle);
  opacitySection.appendChild(opacitySlider);

  colorPickerMain.appendChild(colorSection);
  colorPickerMain.appendChild(opacitySection);
  return {
    main: colorPickerMain,
    getTarget,
    setTarget,
    setOpacity,
  };
}
